/**
 * ErpVisitesSecuritePage — page de suivi des visites de sécurité ERP (item 4.5).
 *
 * Enveloppe le panneau dans la navigation du service technique : le suivi ERP
 * relève du parc bâtimentaire, au même titre que les véhicules et le matériel.
 */
import { AppHeader } from '@/components/AppHeader';
import { ServiceTechniqueNav } from '@/components/ServiceTechniqueNav';
import { ErpVisitesSecuritePanel } from './ErpVisitesSecuritePanel';

export function ErpVisitesSecuritePage() {
  return (
    <>
      {/* Le bandeau mairie manquait sur ce seul onglet du service technique :
          on y arrivait sans pouvoir revenir au tableau de bord (28/07). */}
      <AppHeader module="Service technique" accent="tech" />
      <ServiceTechniqueNav active="visites_erp" />
      <main id="main-content" className="mx-auto max-w-5xl px-4 py-6 sm:px-6">
        <ErpVisitesSecuritePanel />
      </main>
    </>
  );
}
